import AxiosClient from "../../../services/axios.services";

class CategoriaDesempenioServices {
  getCategoriasDesempenio = params =>
    AxiosClient.get("/api/app/categoria_desempeno/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getCategoriaDesempenio = id =>
    AxiosClient.get(`/api/app/categoria_desempeno/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCategoriaDesempenio = data =>
    AxiosClient.post("/api/app/categoria_desempeno/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCategoriaDesempenio = (id, data) =>
    AxiosClient.put(
      `/api/app/categoria_desempeno/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteCategoriaDesempenio = id =>
    AxiosClient.delete(`/api/app/categoria_desempeno/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CategoriaDesempenioServices();